import { DataBean } from "../DataBean";

export class DepreciationUnitsConstants extends DataBean {


    public async getDepreciationUnitsConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDepreciationUnitsConstants_Number", [id]);
    }
}